import React, { Component } from 'react';
import {Button} from 'react-bootstrap';
import { handleFieldChange, handleCheckboxChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import Icon from '../../../../components/Icon';
import device from '../../device.config';

class Form extends Component {
    constructor(props) {
        super(props);

        if(this.props.feed) {
            const { feed } = this.props;

            this.state = {
                id: feed.id,
                name: feed.name,
                factor: feed.factor,
                device: feed.device,
                roi: feed.roi,
                partnerId: `${feed.partnerId}`,
                defaultOfferId: `${feed.defaultOfferId}`,
                update: true
            };
        }
        else {
            this.state = {
                name: '',
                factor: '',
                device: '',
                partnerId: '',
                defaultOfferId: '',
                roi: '',
            };
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleCheckboxChange = handleCheckboxChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(Object.assign({}, this.state));
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px" }}>
                    <FieldGroup
                        name="name"
                        label="Name:"
                        onChange={this.handleFieldChange}
                        value={this.state.name}
                        required
                    />
                    <FieldGroup
                        name="factor"
                        label="Factor:"
                        onChange={this.handleFieldChange}
                        value={this.state.factor}
                        type={'number'}
                        step={'0.01'}
                        max={'10'}
                        required
                    />
                    <SelectWrap
                        name="partnerId"
                        label="Partner:"
                        values={this.props.partners}
                        value={this.state.partnerId}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <SelectWrap
                        name="defaultOfferId"
                        label="Default Offer:"
                        values={this.props.defaultOffers}
                        value={this.state.defaultOfferId}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <SelectWrap
                        name="device"
                        label="Device:"
                        values={device}
                        value={this.state.device}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <FieldGroup
                        name="roi"
                        label="ROI:"
                        onChange={this.handleFieldChange}
                        value={this.state.roi}
                        type={'number'}
                        step={'0.01'}
                        max={'10'}
                    />

                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/scenes/AdkBannerFeeds/components/Form/index.js